import React from 'react';
import { motion } from 'framer-motion';
export function PricingCTA() {
  return <section className="pt-8 md:pt-12 pb-16 md:pb-32 bg-matrix-black relative overflow-hidden px-4" data-id="element-123">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-matrix-green/10 via-matrix-black to-matrix-black opacity-60" data-id="element-124"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-126">
          <div id="precio" className="scroll-mt-8" data-id="element-127">
            <div className="mb-6" data-id="element-128">
              <span className="text-matrix-white/50 line-through text-lg md:text-xl font-light mr-3" data-id="element-129">
                $19.99
              </span>
              <span className="text-matrix-green font-cinzel text-5xl md:text-6xl font-bold drop-shadow-[0_0_15px_rgba(0,255,65,0.5)]" data-id="element-130">
                $6.39
              </span>
            </div>
            <p className="text-matrix-green/80 text-xs md:text-sm uppercase tracking-widest mb-8" data-id="element-131">
              Precio especial por tiempo limitado
            </p>

            <motion.a href="https://tuserenequilibrio.com/cart/51604831895873:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(0,255,65,0.8)'
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-matrix-green text-matrix-black font-inter font-bold text-xl md:text-2xl px-8 md:px-12 py-4 md:py-5 rounded-sm uppercase tracking-wider transition-all duration-300 shadow-[0_0_20px_rgba(0,255,65,0.4)]" data-id="element-132">
              COMPRAR AHORA
            </motion.a>

            <p className="mt-6 text-matrix-green/60 text-xs md:text-sm tracking-widest uppercase" data-id="element-133">
              Acceso instantáneo • Formato Digital
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}